// extracted by mini-css-extract-plugin
export default {"garland":"SlVwWRr0","garlandImage":"nYSyXEqX","garlandGlow":"qyV3mxt6","garlandCircle":"FktWrgy9"};